import * as React from 'react';
import { Tabs, Icon, Table, Skeleton } from 'antd';
import { AddState } from './AddState';
import { StateNodeEdge, StateNodeConnection } from '../../../schema';
import { GraphqlQuery } from 'requestapijs';
import { stateQuery } from './constant';
import { Pagination } from 'sha-el-design/lib';
import { checkAddPermission } from '../../helper';
import { UserService } from '../../../service/UserService';
import { UserNodeEdge } from '../../user/constants';

export class State extends React.Component<Props, S> {
  constructor(props: Props) {
    super(props);
    this.state = {
      states: [],
      activeKey: '1',
      currentPage: 1,
      selectedState: null,
      after: '',
      user: null,
    };
  }

  userService = new UserService();

  componentDidMount() {
    this.userService?.user$.subscribe((user) =>
      this.setState({ user: user?.user }),
    );
  }

  handleTabChange = (activeKey: string) => {
    if (activeKey === '1') {
      this.setState({ activeKey, selectedState: null });
      return;
    }
    this.setState({ activeKey });
  };

  stateColumns = [
    {
      title: 'Name',
      dataIndex: 'node.name',
      key: 'name',
      render: (text, obj) => (
        <a
          onClick={() => {
            this.setState({ selectedState: obj, activeKey: '2' });
          }}
        >
          {text}
        </a>
      ),
      sortingValue: (text) => text,
    },
    {
      title: 'GST Code',
      dataIndex: 'node.gstCode',
      key: 'gstCode',
    },
  ];

  afterStack = [''];

  onPageChange = (next: boolean, after: string, nextPage: boolean) => {
    if (next && nextPage) {
      this.setState({ after, currentPage: this.state.currentPage + 1 });
      this.afterStack.push(after);
    } else if (!next && this.afterStack.length > 1) {
      this.afterStack.pop();
      this.setState({
        after: this.afterStack[this.afterStack.length - 1],
        currentPage: this.state.currentPage - 1,
      });
    }
  };
  render() {
    if (this.state.user && !checkAddPermission(this.state.user))
      return <h1>Access Denied</h1>;
    return (
      <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange}>
        <Tabs.TabPane
          tab={
            <span>
              <Icon type="table" />
              State List
            </span>
          }
          key="1"
          closable={false}
        >
          <GraphqlQuery
            queryString={stateQuery}
            variables={{
              activeKey: this.state.activeKey,
            }}
            render={(
              response: { allStates: StateNodeConnection },
              error,
              loading,
            ) => {
              if (loading) return <Skeleton active />;
              if (response) {
                return [
                  <Table
                    key="table"
                    dataSource={response.allStates.edges}
                    columns={this.stateColumns}
                    rowKey={(obj) => obj.node?.id || ''}
                    pagination={false}
                  />,
                  <Pagination
                    key="pagination"
                    totalCount={Infinity}
                    currentPage={this.state.currentPage}
                    batchSize={20}
                    cursorBasedPagination
                    onChange={(_p, _ps, next) =>
                      this.onPageChange(
                        next,
                        response.allStates.pageInfo.endCursor,
                        response.allStates.pageInfo.hasNextPage,
                      )
                    }
                    style={{ float: 'right' }}
                  />,
                ];
              }
              return <Skeleton active />;
            }}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <span>
              <Icon type="plus" />
              Add State
            </span>
          }
          key="2"
        >
          <AddState
            handleTabChange={this.handleTabChange}
            state={this.state.selectedState?.node}
          />
        </Tabs.TabPane>
      </Tabs>
    );
  }
}

interface Props {}
interface S {
  activeKey: string;
  after: string;
  currentPage: number;
  states: [];
  selectedState: StateNodeEdge | null;
  user?: UserNodeEdge | null;
}
